/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class FilterOptionsBase {
    getFixupPrototypeFunction() { return FilterOptionsBase.fixupPrototype; }

    static newInstance(model: Partial<FilterOptionsBase>): FilterOptionsBase {
        let obj = Object.assign(new FilterOptionsBase(), model);
        FilterOptionsBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<FilterOptionsBase>): FilterOptionsBase {
        if (!model) return null;
        return FilterOptionsBase.newInstance(<FilterOptionsBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: FilterOptionsBase) {
        if (!obj) return;

        models.FilterOptionsBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: FilterOptionsBase): boolean {
        Object.setPrototypeOf(obj, FilterOptionsBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    tenant_id: string;

    /**
     * Has active accounts
     */
    has_active_accounts: boolean = false;

    tenant_name: string;

    /**
     * List of tag key/value pairs
     */
    tags: Array<models.KeyValuePair>;

}
